import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LOGIN } from '../../shared/routes/path';
import Loader from '../../shared/components/common/loader/Loader';
import { verifyEmail } from './services/VerifyEmailService';

const VerifyEmailPage: React.FC = () => {
  const { hash } = useParams<{ hash: string }>();
  const navigate = useNavigate();
  // Potwierdzenie zużywa hash, więc drugie wywołanie efektu (StrictMode w dev) dostałoby 400 i pokazało
  // błąd po udanej weryfikacji. Ten sam strażnik co w InviteAcceptPage.
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;
    if (hash) {
      verifyEmail(hash)
        .then((res) => {
          // Konta klientów API (np. masterclass) wracają na stronę klienta, nie na nasz login.
          const redirectUrl: string | undefined = res?.data?.redirectUrl;
          if (redirectUrl) {
            window.location.replace(redirectUrl);
            return;
          }
          navigate(LOGIN, { state: { emailVerified: 'success' }, replace: true });
        })
        .catch((err) => {
          const expired = err?.response?.data?.error === 'VERIFICATION_LINK_EXPIRED';
          navigate(LOGIN, { state: { emailVerified: expired ? 'expired' : 'error' }, replace: true });
        });
    } else {
      navigate(LOGIN, { state: { emailVerified: 'error' }, replace: true });
    }
  }, []);

  return <Loader />;
};

export default VerifyEmailPage;
